import React from 'react';
import SEOHelmet from '../SEOHelmet';

const TopPsychiatristGreenPark: React.FC = () => {
  return (
    <div className="bg-white text-pink-700 min-h-screen p-8">
      <SEOHelmet />
      <h1 className="text-4xl font-bold mb-6">Dr. Bushra Zahoor - Psychiatrist Serving Green Park, Delhi</h1>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Comprehensive Psychiatric Care for Green Park</h2>
        <p className="mb-4">Dr. Bushra Zahoor, MBBS (Gold Medalist), MD, DNB (Psychiatry), provides clinical psychiatric services for patients from Green Park and South Delhi at Asiaz Hospital, offering evaluation and care for psychiatric conditions.</p>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Comprehensive Psychiatric Services:</h3>
        <ul className="list-disc list-inside">
          <li>Depression and Anxiety Treatment</li>
          <li>Bipolar Disorder Management</li>
          <li>Psychosis and Other Mental Disorders</li>
          <li>Counselling and Psychotherapy</li>
          <li>Relationship Issues</li>
          <li>Migraine Treatment</li>
        </ul>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Dr. Bushra's Expertise:</h3>
        <ul className="list-disc list-inside">
          <li>MBBS (Gold Medalist), MD (Psychiatry), DNB (Psychiatry)</li>
          <li>Specialized training in advanced psychiatric interventions</li>
          <li>Holistic approach to mental health and well-being</li>
          <li>Expert in treating complex mental health disorders</li>
        </ul>
      </section>
      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Contact Information:</h3>
        <p>Phone: +91-9310330922</p>
        <p>Email: bushra.zhro7@gmail.com</p>
        <p>Address: Plot No. 140, Sector 15 Part 2, Near Mother Dairy, Gurugram, Haryana - 122001</p>
      </section>
      <section>
        <h3 className="text-xl font-semibold mb-4">Why Choose Dr. Bushra in Green Park?</h3>
        <p>Dr. Bushra Zahoor offers a professional and confidential setting for clinical mental health care at Asiaz Hospital. Her clinical approach provides evidence-based care tailored to individual diagnostic and care requirements for conditions such as depression, anxiety, relationship issues, and other mental health concerns.</p>
        <p className="mt-4">Consultations are available for residents of South Delhi. Schedule a consultation with Dr. Bushra Zahoor at Asiaz Hospital.</p>
      </section>
    </div>
  );
};

export default TopPsychiatristGreenPark;